import './CategoryTabs.css'

interface CategoryTabsProps {
  activeCategory: string
  onCategoryChange: (category: string) => void
  categoryCounts: { [key: string]: number }
}

function CategoryTabs({ activeCategory, onCategoryChange, categoryCounts }: CategoryTabsProps) {
  const categories = [
    { key: 'all', label: 'Tous les documents', icon: '📚' },
    { key: 'flyers', label: 'Tracts', icon: '📄' },
    { key: 'programme', label: 'Programme', icon: '📋' },
    { key: 'communiques', label: 'Communiqués', icon: '📢' },
    { key: 'autres', label: 'Autres', icon: '📁' }
  ]

  const getCount = (key: string): number => {
    if (key === 'all') {
      return Object.values(categoryCounts).reduce((sum, count) => sum + count, 0)
    }
    return categoryCounts[key] || 0
  }

  return (
    <div className="category-tabs">
      <div className="category-tabs-scroll">
        {categories.map((category) => {
          const count = getCount(category.key)
          return (
            <button
              key={category.key}
              className={`category-tab ${activeCategory === category.key ? 'active' : ''}`}
              onClick={() => onCategoryChange(category.key)}
              disabled={count === 0}
            >
              <span className="category-tab-icon">{category.icon}</span>
              <span className="category-tab-label">{category.label}</span>
              <span className="category-tab-count">{count}</span>
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default CategoryTabs
